import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_get_shipping_containers_contentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shippingContainerId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, TasksForExpectedTargetShippingContainer?: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, MaterialId?: number, ShipmentId?: number, WarehouseId?: number, ExpectedPackagedPack?: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number, MaterialsPackagingsLookup?: { IsConveyable?: boolean }[] }, ExpectedSourceLocation?: { Id?: number, Name?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_shipping_containers_contents/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { shippingContainerId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, TasksForExpectedTargetShippingContainer?: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, MaterialId?: number, ShipmentId?: number, WarehouseId?: number, ExpectedPackagedPack?: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number, MaterialsPackagingsLookup?: { IsConveyable?: boolean }[] }, ExpectedSourceLocation?: { Id?: number, Name?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_shipping_containers_contents/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { shippingContainerId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, TasksForExpectedTargetShippingContainer?: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, MaterialId?: number, ShipmentId?: number, WarehouseId?: number, ExpectedPackagedPack?: { Id?: number, Height?: number, Length?: number, Name?: string, Weight?: number, Width?: number, MaterialsPackagingsLookup?: { IsConveyable?: boolean }[] }, ExpectedSourceLocation?: { Id?: number, Name?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_shipping_containers_contents/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shippingContainerId?: number    }) {
      return false;
    }
}
